import { createSlice } from "@reduxjs/toolkit";
// api
import { addAddressBookAPI, deleteAddressBookAPI, editAddressBookAPI, getAddressBooksAPI, markAddressBookAsDefaultAPI } from "src/api";
// utils
import { getAddressListBody } from "src/utils/get-request-data";
import { trimObject } from "src/utils/format-object";

// ----------------------------------------------------------------------

const initialState = {
    isLoading: false,
    error: null,
    // ----------------------------------
    addressShipFromData: {},
    addressShipFromFilter: {
        category: "SHIP_FROM",
        // page: 1,
        // page_size: 25,
    },
    //
    addressShipToData: {},
    addressShipToFilter: {
        category: "SHIP_TO",
        // page: 1,
        // page_size: 25,
    }
};

const slice = createSlice({
    name: "address",
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },

        stopLoading(state) {
            state.isLoading = false;
        },

        hasError(state, action) {
            state.isLoading = false;
            //
            state.error = action.payload;
        },

        clearError(state) {
            state.error = null;
        },

        // GET ADDRESSES LIST
        getAddressesShipFromSuccess(state, action) {
            state.addressShipFromData = action.payload;

        },

        getAddressesShipToSuccess(state, action) {
            state.addressShipToData = action.payload;

        }
    }
});

// Reducer
export default slice.reducer;

// Actions
export const {
    clearError
} = slice.actions;

// ----------------------------------------------------------------------

export function getShipFromAddressList(filter) {
    return async (dispatch, getState) => {
        try {
            dispatch(slice.actions.startLoading());

            const localFilter = { ...getState().address.addressShipFromFilter, ...filter };

            const { status, data } = await getAddressBooksAPI({
                ...trimObject(getAddressListBody(localFilter))(["total"])
            });

            if (status === 200) {
                dispatch(slice.actions.getAddressesShipFromSuccess(data?.data ?? {}));
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        } finally {
            dispatch(slice.actions.stopLoading());
        }
    };
}

// ----------------------------------------------------------------------

export function getShipToAddressList(filter) {
    return async (dispatch, getState) => {
        try {
            dispatch(slice.actions.startLoading());

            const localFilter = { ...getState().address.addressShipToFilter, ...filter };
            const { status, data } = await getAddressBooksAPI({
                ...trimObject(getAddressListBody(localFilter))(["total"])
            });

            if (status === 200) {
                dispatch(slice.actions.getAddressesShipToSuccess(data?.data ?? {}));
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        } finally {
            dispatch(slice.actions.stopLoading());
        }
    };
}

// ----------------------------------------------------------------------

export function addAddress(request) {
    return async (dispatch) => {
        try {
            dispatch(slice.actions.startLoading());

            const { status, data } = await addAddressBookAPI(request);

            if (status === 200 && data?.code === "ok") {
                if (request.address_type === "SHIP_FROM") {
                    dispatch(getShipFromAddressList());
                }

                if (request.address_type === "SHIP_TO") {
                    dispatch(getShipToAddressList());
                }
            }

            return status === 200 && data?.code === "ok";
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            //
            return false;
        } finally {
            dispatch(slice.actions.stopLoading());
        }
    };
}

// ----------------------------------------------------------------------

export function deleteAddress(id, category) {
    return async (dispatch) => {
        try {
            dispatch(slice.actions.startLoading());

            const { status, data } = await deleteAddressBookAPI(id);

            if (status === 200 && data?.code === "ok") {
                if (category === "SHIP_FROM") {
                    dispatch(getShipFromAddressList());
                }

                if (category === "SHIP_TO") {
                    dispatch(getShipToAddressList());
                }
            }

            return status === 200 && data?.code === "ok";
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            //
            return false;
        } finally {
            dispatch(slice.actions.stopLoading());
        }
    };
}

// ----------------------------------------------------------------------

export function modifyAddress(request) {
    return async (dispatch) => {
        try {
            dispatch(slice.actions.startLoading());
            const params = { ...request}
            delete params.address_type
            const { status, data } = await editAddressBookAPI(params);
            if (status === 200 && data?.code === "ok") {
                if (request.address_type === "SHIP_FROM") {
                    dispatch(getShipFromAddressList());
                }

                if (request.address_type === "SHIP_TO") {
                    dispatch(getShipToAddressList());
                }
            }
            return status === 200 && data?.code === "ok";
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            //
            return e;
        } finally {
            dispatch(slice.actions.stopLoading());
        }
    };
}

// ----------------------------------------------------------------------

export function markAsDefault(id, category) {
    return async (dispatch) => {
        try {
            dispatch(slice.actions.startLoading());

            const { status, data } = await markAddressBookAsDefaultAPI({ id, address_type: category });

            if (status === 200 && data?.code === "ok") {
                if (category === "SHIP_FROM") {
                    dispatch(getShipFromAddressList());
                }

                if (category === "SHIP_TO") {
                    dispatch(getShipToAddressList());
                }
            }

            return status === 200 && data?.code === "ok";
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            //
            return false;
        } finally {
            dispatch(slice.actions.stopLoading());
        }
    };
}
